import { skipToken, useQuery } from '@tanstack/react-query';
import type { FeatureOptions } from '../../types/domain';
import { useCurrentSimDataId } from '../SimViewer/useCurrentSimDataId';
import { dataApiClient } from '../../infrastructure/dataApi/client';

type UseFeatureOptionsData = {
  isLoading: boolean;
  featureOptions: FeatureOptions | null;
};

const useFeatureOptionsData = (): UseFeatureOptionsData => {
  const { currentSimDataId } = useCurrentSimDataId();

  const { data, isFetching } = useQuery({
    queryKey: ['featureOptions', currentSimDataId],
    queryFn: currentSimDataId
      ? async (): Promise<FeatureOptions> => {
          return dataApiClient.getFeatureOptions(currentSimDataId);
        }
      : skipToken,
    meta: { dataType: 'others' },
  });

  return { isLoading: isFetching, featureOptions: data ?? null };
};

export { useFeatureOptionsData };
